import { ArticleParagraph2, IconClose12 } from '@cian/ui-kit';
import * as React from 'react';

import { BannerWrapper } from '../../BannerWrapper';
import userFolder from './icons/userFolder.png';
import * as styles from './styles.css';

export interface IBannerProps {
  onClick(): void;
  onClose(): void;
  isSearchResultsOpen?: boolean;
  rootClassName?: string;
  href?: string;
}

export const Banner: React.FC<IBannerProps> = ({ onClick, onClose, isSearchResultsOpen, rootClassName, href }) => {
  return (
    <BannerWrapper
      moveRight={isSearchResultsOpen}
      attributes={{ className: rootClassName, 'data-testid': 'CPD-Banner' }}
    >
      <button className={styles['close']} onClick={onClose}>
        <IconClose12 />
      </button>
      <div className={styles['content']}>
        <div className={styles['img']}>
          <img src={userFolder} alt="" />
        </div>
        <div>
          <ArticleParagraph2>Профи от&nbsp;Циана поможет купить</ArticleParagraph2>
          <ArticleParagraph2>недвижимость выгодно и&nbsp;спокойно</ArticleParagraph2>
          {href ? (
            <a href={href} onClick={onClick} className={styles['link']}>
              Узнать, как поможет
            </a>
          ) : null}
        </div>
      </div>
    </BannerWrapper>
  );
};

Banner.displayName = 'CPDBanner';
